/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { createBrowserRouter, RouterProvider } from 'react-router';

import { ExternalAppProviders } from 'shared-ui/external-app-base';

import { routes } from './routes/routes';

const router = createBrowserRouter(routes);

export default function App() {
    return (
        <ExternalAppProviders mountRateLimitNotice={false}>
            <RouterProvider router={router} />
        </ExternalAppProviders>
    );
}

if (process.env.REACT_AXE_ENV === 'local') {
    const [{ default: axe }, { default: React }, { default: ReactDOM }] =
        await Promise.all([
            import('@axe-core/react'),
            import('react'),
            import('react-dom'),
        ]);
    axe(React, ReactDOM, 5000);
}
